module.exports = __webpack_public_path__ + "img/sign-up-corner-flag.d79b675a.png";